export default (value) => parseFloat(value).toLocaleString('pt-BR')
